export type ColorKeys =
  | 'gray'
  | 'dark-gray'
  | 'primary'
  | 'secondary'
  | 'success'
  | 'warning'
  | 'error';

export enum Color {
  inherit = 'inherit',

  gray900 = 'rgb(var(--colors-gray-900))',
  gray800 = 'rgb(var(--colors-gray-800))',
  gray700 = 'rgb(var(--colors-gray-700))',
  gray600 = 'rgb(var(--colors-gray-600))',
  gray500 = 'rgb(var(--colors-gray-500))',
  gray400 = 'rgb(var(--colors-gray-400))',
  gray300 = 'rgb(var(--colors-gray-300))',
  gray200 = 'rgb(var(--colors-gray-200))',
  gray100 = 'rgb(var(--colors-gray-100))',
  gray050 = 'rgb(var(--colors-gray-050))',
  gray025 = 'rgb(var(--colors-gray-025))',

  primary900 = 'rgb(var(--colors-primary-900))',
  primary800 = 'rgb(var(--colors-primary-800))',
  primary700 = 'rgb(var(--colors-primary-700))',
  primary600 = 'rgb(var(--colors-primary-600))',
  primary500 = 'rgb(var(--colors-primary-500))',
  primary400 = 'rgb(var(--colors-primary-400))',
  primary300 = 'rgb(var(--colors-primary-300))',
  primary200 = 'rgb(var(--colors-primary-200))',
  primary100 = 'rgb(var(--colors-primary-100))',
  primary050 = 'rgb(var(--colors-primary-050))',
  primary025 = 'rgb(var(--colors-primary-025))',

  secondary900 = 'rgb(var(--colors-secondary-900))',
  secondary800 = 'rgb(var(--colors-secondary-800))',
  secondary700 = 'rgb(var(--colors-secondary-700))',
  secondary600 = 'rgb(var(--colors-secondary-600))',
  secondary500 = 'rgb(var(--colors-secondary-500))',
  secondary400 = 'rgb(var(--colors-secondary-400))',
  secondary300 = 'rgb(var(--colors-secondary-300))',
  secondary200 = 'rgb(var(--colors-secondary-200))',
  secondary100 = 'rgb(var(--colors-secondary-100))',
  secondary050 = 'rgb(var(--colors-secondary-050))',
  secondary025 = 'rgb(var(--colors-secondary-025))',

  whiteFull = 'rgb(var(--colors-white-full))',
  whiteOff = 'rgb(var(--colors-white-off))',

  blackFull = 'rgb(var(--colors-black-full))',

  errorDarker = 'rgb(var(--colors-error-darker))',
  errorDark = 'rgb(var(--colors-error-dark))',
  errorBase = 'rgb(var(--colors-error-base))',
  errorLight = 'rgb(var(--colors-error-light))',
  errorLighter = 'rgb(var(--colors-error-lighter))',
  errorLightest = 'rgb(var(--colors-error-lightest))',

  successDarker = 'rgb(var(--colors-success-darker))',
  successDark = 'rgb(var(--colors-success-dark))',
  successBase = 'rgb(var(--colors-success-base))',
  successLight = 'rgb(var(--colors-success-light))',
  successLighter = 'rgb(var(--colors-success-lighter))',
  successLightest = 'rgb(var(--colors-success-lightest))',

  warningDarker = 'rgb(var(--colors-warning-darker))',
  warningDark = 'rgb(var(--colors-warning-dark))',
  warningBase = 'rgb(var(--colors-warning-base))',
  warningLight = 'rgb(var(--colors-warning-light))',
  warningLighter = 'rgb(var(--colors-warning-lighter))',
  warningLightest = 'rgb(var(--colors-warning-lightest))',

  infoDarker = 'rgb(var(--colors-info-darker))',
  infoDark = 'rgb(var(--colors-info-dark))',
  infoBase = 'rgb(var(--colors-info-base))',
  infoLight = 'rgb(var(--colors-info-light))',
  infoLighter = 'rgb(var(--colors-info-lighter))',
  infoLightest = 'rgb(var(--colors-info-lightest))',

  darkRed = 'rgb(var(--colors-dark-red))',
  darkOrange = 'rgb(var(--colors-dark-orange))',
  darkYellow = 'rgb(var(--colors-dark-yellow))',
  aquaBlue = 'rgb(var(--colors-aqua-blue))',
  darkBlue = 'rgb(var(--colors-dark-blue))',
  blue = 'rgb(var(--colors-blue))',
  brown = 'rgb(var(--colors-brown))',
  purple = 'rgb(var(--colors-purple))',
  green = 'rgb(var(--colors-green))',
  grayBlue = 'rgb(var(--colors-gray-blue))',

  chartBlue = 'rgb(var(--colors-chart-blue))',
  chartBluePale = 'rgb(var(--colors-chart-blue-pale))',
  chartGreen = 'rgb(var(--colors-chart-green))',
  chartGreenPale = 'rgb(var(--colors-chart-green-pale))',
  chartOrange = 'rgb(var(--colors-chart-orange))',
  chartOrangePale = 'rgb(var(--colors-chart-orange-pale))',
  chartPink = 'rgb(var(--colors-chart-pink))',
  chartPinkPale = 'rgb(var(--colors-chart-pink-pale))',
  chartPurple = 'rgb(var(--colors-chart-purple))',
  chartPurplePale = 'rgb(var(--colors-chart-purple-pale))',
  chartRed = 'rgb(var(--colors-chart-red))',
  chartRedPale = 'rgb(var(--colors-chart-red-pale))',
}
